import styled from '@emotion/styled';
import { Dialog } from '@gumtree/ui-library';
import {
    fontWeights,
    colorVariables,
    fontSizes,
    mediaQuery,
    breakpoints,
    lineHeights,
} from '@gumtree/ui-library/src/base/theme';

export const StyledDialog = styled(Dialog)`
    width: 460px;
    border-radius: 8px;
    padding: 0;

    .dialog-content {
        padding: 32px;
    }

    .dialog-close .icon {
        font-size: ${fontSizes.base};
    }

    ${mediaQuery.until(breakpoints.medium)} {
        width: 280px;
        min-width: 280px;
    }
`;

export const ReportWrapper = styled.div`
    width: 100%;
    
    ${mediaQuery.from(breakpoints.medium)} {
        padding: 16px 0 40px 0;
    }

    ${mediaQuery.until(breakpoints.medium)} {
        padding: 16px 0 32px 0;
    }
`;

export const ReportDesc = styled.div`
    font-size: ${fontSizes.base};
    font-weight: ${fontWeights.normal};
    line-height: ${lineHeights.base};
    color: ${colorVariables.textPrimary};
    margin-bottom: 16px;
`;
